import { instance } from "./axios";
import * as actions from "../../actionTypes";
import { authHeader } from "../../../helpers/authHeader";

const GET_CURRENT_SERVICES = "GET_CURRENT_SERVICES";
const GET_CURRENT_SERVICES_SUCCESS = "GET_CURRENT_SERVICES_SUCCESS";
const GET_CURRENT_SERVICES_FAILURE = "GET_CURRENT_SERVICES_FAILURE";

const baseURL = process.env.REACT_APP_SERVICE_URL;

const initialState = {
  servicesAPI: []
};

// Reducer

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CURRENT_SERVICES_SUCCESS:
      return {
        ...state,
        servicesAPI: action.payload
      };
    case GET_CURRENT_SERVICES:
    case GET_CURRENT_SERVICES_FAILURE: {
      return initialState;
    }
    case actions.CLEAR_ALL: {
      return initialState;
    }
    default:
      return state;
  }
};

export const getEnvVariables = () => {
  return (dispatch) => {
    return instance
      .get(`${baseURL}env/vars`, {
        headers: Object.assign(
          { "Content-Type": "application/json" },
          authHeader()
        )
      })
      .then(
        (response) => {
          if (response.status === 200) {
            dispatch({
              type: GET_CURRENT_SERVICES_SUCCESS,
              payload: response["data"]
            });
            return response["data"];
          } else {
            dispatch({ type: GET_CURRENT_SERVICES_FAILURE });
          }
        },
        (err) => {
          console.log("ERROR", err);
          dispatch({ type: GET_CURRENT_SERVICES_FAILURE });
          return false;
        }
      );
  };
};

export const checkAdminAction = (accessCode, apiGateWay) => {
  return (dispatch) => {
    return instance
      .post(
        `${apiGateWay}/admin/account?account=${accessCode}`,
        {},
        {
          headers: Object.assign(
            { "Content-Type": "application/json" },
            authHeader()
          )
        }
      )
      .then(
        (response) => {
          if (response.status === 200) {
            dispatch({
              type: GET_CURRENT_SERVICES_SUCCESS,
              payload: response["data"]
            });
            return response["data"];
          } else {
            dispatch({ type: GET_CURRENT_SERVICES_FAILURE });
          }
        },
        (err) => {
          console.log("ERROR", err);
          dispatch({ type: GET_CURRENT_SERVICES_FAILURE });
          return false;
        }
      );
  };
};

export const checkHealthAction = () => {
  return (dispatch) => {
    return instance
      .get(`${baseURL}health`, {
        headers: Object.assign(
          { "Content-Type": "application/json" },
          authHeader()
        )
      })
      .then(
        (response) => {
          if (response.status === 200) {
            dispatch({
              type: GET_CURRENT_SERVICES_SUCCESS,
              payload: response["data"]["healthCheck"]
            });
            return response["data"]["healthCheck"];
          } else {
            dispatch({ type: GET_CURRENT_SERVICES_FAILURE });
          }
        },
        (err) => {
          console.log("ERROR", err);
          dispatch({ type: GET_CURRENT_SERVICES_FAILURE });
          throw new Error(`Error in getting services`);
        }
      );
  };
};

export const getServicesAPIAction = () => {
  return (dispatch) => {
    dispatch({ type: GET_CURRENT_SERVICES });
    return instance
      .get(`${baseURL}services`, {
        headers: Object.assign(
          { "Content-Type": "application/json" },
          authHeader()
        )
      })
      .then(
        (response) => {
          if (response.status === 200) {
            dispatch({
              type: GET_CURRENT_SERVICES_SUCCESS,
              payload: response["data"]["serviceDataResponseList"]
            });
            return response["data"]["serviceDataResponseList"];
          } else {
            dispatch({ type: GET_CURRENT_SERVICES_FAILURE });
          }
        },
        (err) => {
          dispatch({ type: GET_CURRENT_SERVICES_FAILURE });
          throw new Error(`Error in getting services`);
        }
      );
  };
};

export const checkSIN = (sinData) => {
  const data = sinData;
  return (dispatch) => {
    return instance
      .post(`${baseURL}sincheck`, data, {
        headers: Object.assign(
          { "Content-Type": "application/json" },
          authHeader()
        )
      })
      .then(
        (response) => {
          if (response.status === 200) {
            dispatch({
              type: GET_CURRENT_SERVICES_SUCCESS,
              payload: response["data"]["sinCheckResponse"]
            });
            return response["data"]["sinCheckResponse"];
          } else {
            dispatch({ type: GET_CURRENT_SERVICES_FAILURE });
          }
        },
        (err) => {
          console.log("ERROR", err);
          dispatch({ type: GET_CURRENT_SERVICES_FAILURE });
          throw new Error(`Error in getting services`);
        }
      );
  };
};

export const getApplicationStatus = (confirmationData) => {
  const data = confirmationData;
  console.log(data);
  return (dispatch) => {
    dispatch({ type: GET_CURRENT_SERVICES });
    return instance
      .post(`${baseURL}harp/status`, data, {
        headers: Object.assign(
          { "Content-Type": "application/json" },
          authHeader()
        )
      })
      .then(
        (response) => {
          if (response.status === 200) {
            dispatch({
              type: GET_CURRENT_SERVICES_SUCCESS,
              payload: response["data"]
            });
            return response["data"];
          } else {
            dispatch({ type: GET_CURRENT_SERVICES_FAILURE });
          }
        },
        (err) => {
          dispatch({ type: GET_CURRENT_SERVICES_FAILURE });
          throw new Error(`Error in getting services`);
        }
      );
  };
};
// export const getServicesAPIAction = () => {
//   return hardData['serviceDataResponseList']
// }
